/* eslint-disable class-methods-use-this */
import BillEntity from 'utils/__interfaces/Billings/BillEntity'
import BillWDH from 'utils/__interfaces/Billings/BillWDH'
import {
  to1stDayOfMonth,
  formatDate,
  toLastDayOfMonth,
  parseDate,
  getYear,
  getMonth,
  getTrim,
} from 'utils/Common/date-utils'

class BillNormalizer {
  normalize(billList: BillWDH[]): BillEntity[] {
    return billList.map((bill) => {
      return this.normalizeSingle(bill)
    })
  }

  normalizeSingle(bill: BillWDH): BillEntity {
    const {
      idFacture,
      numFacture,
      dateFacturation,
      montantTotalHT,
      type,
      fketablissemententrepriseclient,
      fkstatutfacture,
    } = bill

    const dateObj = parseDate(dateFacturation)

    const principalAddress = fketablissemententrepriseclient.adresses.find(
      (address) => address.typeAdresse === 'Principale'
    )

    let address = ''
    if (principalAddress) {
      const { rueAdresse, villeAdresse, codePostalAdresse } = principalAddress
      address += `${rueAdresse || ''} ${codePostalAdresse || ''} ${
        villeAdresse || ''
      }`
    }

    const { cycleFacturation } = fketablissemententrepriseclient
    // default "mensuel"
    const interval =
      cycleFacturation === 'TRIM'
        ? `du ${formatDate(getTrim(dateObj)[0])} au ${formatDate(
            getTrim(dateObj)[1]
          )}`
        : `du ${formatDate(to1stDayOfMonth(dateObj))} au ${formatDate(
            toLastDayOfMonth(dateObj)
          )}`

    let status = ''
    if (fkstatutfacture?.statut === 'Partiel') {
      status = 'closed'
    } else if (fkstatutfacture?.statut === 'Complet') {
      status = 'paid'
    } else {
      status = 'notPaid'
    }

    return {
      id: idFacture,
      number: `N°${numFacture}`,
      status,
      price: montantTotalHT,
      date: dateObj,
      formattedDate: formatDate(dateObj),
      formattedDateAsYearMonth: `${getMonth(dateObj)} ${getYear(dateObj)}`,
      type,
      linkDL: '?', // TODO to dynamize
      name: fketablissemententrepriseclient.raisonSociale,
      address,
      // TODO translation
      interval,
    }
  }
}

export default new BillNormalizer()
